export default __webpack_public_path__ + "f7f2661f6e3c07574275a031750b9182.svg";